import PageTemplate from "../components/common/PageTemplate";
import ListMyAddress from "../screen/locationAddress/ListMyAddress";

const ListMyAddressPage = () => {
  return (
    <PageTemplate
      mainComponent={<ListMyAddress />}
      noPadding={true}
      logo="Alamat Saya"
      back="/location-address"
    />
  );
};

export default ListMyAddressPage;
